import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const defaultState: CartStoreState = {
    cartInfo: {},
    value2RefreshOfCart: '',
};
export const useAnonymousCartStore = create<CartStoreState & CartStoreAction>()(
    persist(
        (set) => ({
            ...defaultState,
            setCartInfo: (cartInfo) => set(() => ({ cartInfo })),
            refreshCart: () => set(() => ({ value2RefreshOfCart: new Date().toISOString() })),
        }),
        {
            name: 'useAnonymousCart-storage',
            storage: createJSONStorage(() => sessionStorage),
        },
    ),
);

interface CartStoreState {
    cartInfo: {
        [mallId: string]: {
            mallId: string;
            productList: CartStoreStateProduct[]
        };
    };
    value2RefreshOfCart: string;
}
export interface CartStoreStateProduct {
    productGroupId: string;
    representProductId: string;
    representProductName: string;
    representProductImage: string;
    discountMethod: 'percent' | 'won';
    discountValue: number;
    productId: string;
    productOptionsName: string;
    productPrice: number;
    productAmount: number;
    totalProductPrice: number;
    ownerType: 'SELLER' | 'VENDOR';
    productShippingPolicy: {
        shippingCost: number;
        islandMountainShippingCost: number;
        freeShippingCostBar: number;
        islandMountainDiscountShippingCostBar: number;
        islandMountainDiscountedPrice: number;
        jejuShippingCost: number;
        jejuDiscountShippingCostBar: number;
        jejuDiscountedPrice: number;
    };
}
interface CartStoreAction {
    setCartInfo: (cartInfo: CartStoreState['cartInfo']) => void;
    refreshCart: () => void;
}
